"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.crimsonAccents = void 0;
exports.crimsonAccents = {
    accentColor: "#ee3344",
    accentColorHover: "#f74555",
    accentColorActive: "#d93847",
};
//# sourceMappingURL=crimsonAccents.js.map